import { ContentBox } from "@arelia-components/ui-atoms/ContentBox";
import Header from "@arelia-components/layout/Header";
import StreamingRoyaltiesContainer from "./StreamingRoyaltiesContainer";

export default function RecordingRoyaltiesDetails() {
  return (
    <ContentBox>
      <Header
        title="Streaming Royalties"
        backTo={{
          label: "back to earnings",
          path: "/earnings"
        }}
      />
      <StreamingRoyaltiesContainer />
    </ContentBox>
  );
}
